import React from 'react';
import useLogin from '../hooks/useLogin';
import useOutsidOfDOMClick from '../../hooks/useOutsidOfDOMClick';
import Label from '../../utils/label';
import {getFullUrlPath} from '../../utils/common'; 

export default function LoginModal({ popupDiv }) {
    const {
        loginData,
        errorMessage,
        onLogin,
        onChange,
        refreshImageHash,
        viewData,
        setRefreshingLoginCode,
        onSignUp,
        onValidationKeyDown
    } = useLogin(popupDiv);

    const loginModalRef = useOutsidOfDOMClick(() => {
        popupDiv(-1);
    }, []);

    return (
        <div className="blocker" data-tag="tagPopupLogin">
            <div ref={loginModalRef} className="modal popup-login" >
                <h2>{Label.lbl_Member_Login}</h2>
                <form>
                    <label className={`login__item ${errorMessage.username ? 'error' : ''}`}>
                        <div className="box-bg">
                            <input
                                id="username"
                                type="text"
                                autoComplete="off"
                                placeholder={Label.lbl_username}
                                value={loginData.username}
                                onChange={onChange}
                            />
                        </div>
                        <div className="error__txt">{errorMessage.username}</div>
                    </label>
                    <label className={`login__item ${errorMessage.password ? 'error' : ''}`}>
                        <div className="box-bg">
                            <input
                                id="password"
                                type="password"
                                autoComplete="off"
                                placeholder={Label.lbl_Passwd}
                                value={loginData.password}
                                onChange={onChange}
                            />
                        </div>
                        <div className="error__txt">{errorMessage.password}</div>
                    </label>
                    <label className={`login__validation ${errorMessage.validation ? 'error' : ''}`}>
                        <div className="box-bg">
                            <input
                                id="validation"
                                type="text"
                                placeholder={Label.lbl_code}
                                value={loginData.validation}
                                onChange={onChange}
                                onKeyDown={onValidationKeyDown}
                            />
                            <img src={getFullUrlPath(`login_code.aspx?${loginData.imageHash}`)} className="garyy" onLoad={() => setRefreshingLoginCode(false)} />
                            <div className={`btn btn-small btn-info ${viewData.refreshingLoginCode ? 'spin' : ''}`} data-tag="tabSmallBtnIcon" onClick={refreshImageHash}>
                                <i className="icon-refresh" />
                            </div>
                        </div>
                        <div className="error__txt">{errorMessage.validation}</div>
                    </label>
                    <label>
                        <input
                            id="rememberMe"
                            type="checkbox"
                            checked={loginData.rememberMe}
                            onChange={onChange}
                        />
                        {Label.lbl_RememberMe}
                    </label>
                    <div className={['btn btn-primary btn-block btn-large', viewData.logining ? 'disable' : ''].join(' ')} onClick={onLogin}>{Label.lbl_login}</div>
                    <div className="footer">
                        <a href="javascript:void(0);" onClick={onSignUp}>{Label.lbl_Signup}</a>∣
                        <a href="javascript:void(0);" onClick={() => popupDiv(1)}>{Label.lbl_Forget}</a>
                    </div>
                </form>
            </div>
        </div>
    );
}